import * as React from "react"
import styled from "styled-components"
import themeGet from "@styled-system/theme-get"
import injectSheet from "react-jss"
import { PageHeader } from "@/components"
import { DateRangeControls, ExportReportButton } from "./components"

const styles = {
  header: { composes: "relative", flexShrink: 0 },
}

const StyledExportReportButton = styled(ExportReportButton)`
  align-self: flex-start;
  margin-right: ${themeGet("space.3")} !important;
`

const PageHeaderWithControls = injectSheet(styles)(
  ({ classes, description, title, comparisonDisabled }) => (
    <PageHeader
      className={classes.header}
      title={title}
      description={description}
      actions={
        <>
          <StyledExportReportButton />
          <DateRangeControls comparisonDisabled={comparisonDisabled} />
        </>
      }
    />
  ),
)

export { PageHeaderWithControls }
